export default "__VITE_ASSET__DOks29sv__"